import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../../Appstore/store';
import { formatDate } from '../../helper';
import { GetallUserLogsReports, UserLogsReports } from '../../Features/reports/Userlogsreports';
import { RenderPaginationButtons } from '../../Components/Paginations';
import { MdClear } from "react-icons/md";
import { Dropdown } from 'react-bootstrap';
import { GetallAgentsAndMonitors } from '../../Features/Getallagentsmonitors'
import CreatableSelect from "react-select";
import { components } from "react-select";
import axiosInstance from '../../api/axiosInstance';
import { BiExport } from 'react-icons/bi';


interface OptionType {
    value: number;
    label: string;
    id: number;
}

function Userlogsreports() {
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [page, setPage] = useState<number>(1);
    const [loadingg, setLoading] = useState<boolean>(false);
    const [hasMore, setHasMore] = useState<boolean>(true);
    const [limit, setLimit] = useState(10);
    const [userlimit, setuserlimit] = useState(10);
    const [userOptions, setUserOptions] = useState<OptionType[]>([])

    const [dateRangeText, setDateRangeText] = useState<string>("Date Filter");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const dispatch = useDispatch<AppDispatch>();
    const [userid, setUserid] = useState('');
    const [modulename, setmodulename] = useState('');
    const [ipaddress, setipaddress] = useState('');
    const [fromDate, setfromDate] = useState('');
    const [toDate, settoDate] = useState('');
    const [isExporting, setIsExporting] = useState(false);

    const { userlogsreportdata, info, loading, error } = useSelector((state: RootState) => state.userlogsreports);
    const recordreport: UserLogsReports | any = userlogsreportdata || [];

    const { agentmonitordata } = useSelector((state: RootState) => state.agentmonitor);
    const username: UserLogsReports | any = agentmonitordata || [];

    const DownloadLogs = async () => {
        setIsExporting(true)
        let quary = `?user_id=${userid ? parseInt(userid, 10) : ""}`;
        quary += `&module_name=${modulename || ""}`;
        quary += `&ip_address=${ipaddress || ""}`;
        quary += `&from_date=${fromDate || ""}`;
        quary += `&to_date=${toDate || ""}`;
        await axiosInstance.get(`/api/admin/reports/user-logs/download${quary}`, { responseType: 'blob' }).then((resp) => {
            setIsExporting(false);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(resp.data)
            link.download = `User_Log_${new Date().toISOString()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },).catch(() => { setIsExporting(false) })
    }

    function debounce(func: (...args: any[]) => void, delay: number) {
        let timer: NodeJS.Timeout;
        return (...args: any[]) => {
            clearTimeout(timer);
            timer = setTimeout(() => func(...args), delay);
        };
    }

    const debouncedSearch = debounce((inputValue: string) => {
        setSearchTerm(inputValue);
        setPage(1);
    }, 700);


    const handleSearchChange = (inputValue: string) => {
        if (inputValue.trim() !== searchTerm) {
            debouncedSearch(inputValue);
        };
    };

    const debouncedFetch = useRef(
        debounce((params) => {
            dispatch(GetallUserLogsReports(params));
        }, 500)
    ).current;

    const fetchReports = () => {
        debouncedFetch({
            user_id: userid ? parseInt(userid, 10) : undefined,
            module_name: modulename,
            ip_address: ipaddress,
            from_date: fromDate,
            to_date: toDate,
            limit: limit,
            page: currentPage
        });
    };

    useEffect(() => {
        fetchReports();
    }, [currentPage, userid, modulename, ipaddress, fromDate, toDate]);


    const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setDateRange((prev) => ({ ...prev, [name]: value }));
    };

    const [dateRange, setDateRange] = useState({
        from: "",
        to: "",
    });

    const formatDateDateFilter = (date: string): string => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const applyDateFilter = () => {
        if (!dateRange.from || !dateRange.to) {
            return;
        }
        setCurrentPage(1)
        const formattedFrom = formatDateDateFilter(dateRange.from);
        const formattedTo = formatDateDateFilter(dateRange.to);

        setDateRangeText(`${formattedFrom} - ${formattedTo}`);

        setfromDate(formattedFrom);
        settoDate(formattedTo);
    };

    const clearDateFilter = () => {
        setDateRange({ from: "", to: "" });
        setDateRangeText("Date Filter")
        setfromDate("")
        settoDate("")
    };


    useEffect(() => {
        setLoading(true)
        if (loadingg) return;
        dispatch(GetallAgentsAndMonitors({ search: searchTerm, page, limit: userlimit }))
            .then((response: any) => {
                const newData: OptionType[] =
                    response?.payload?.data?.map((item: any) => ({
                        value: item.id,
                        label: item.name,
                    })) || [];

                setUserOptions(newData);
                setLoading(true)
                setHasMore(newData.length === limit);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [searchTerm, userlimit]);


    const handleSelectChange = (selectedOption: any) => {
        if (selectedOption) {
            setCurrentPage(1)
            setUserid(selectedOption.value);
        }
    };

    const loadMore = () => {
        if (!loading && hasMore) {
            setuserlimit((pre) => pre + 10);
        }
    };

    const MultiValue = (props: any) => {
        const { children, selectProps } = props;
        return (
            <components.MultiValue {...props}>
                <span>{props.data.label}</span>
            </components.MultiValue>
        );

    };

    const CustomMenuList = (props: any) => {
        const { children, hasMore, loading, loadMore, selectProps } = props;

        return (
            <components.MenuList {...props}>
                {/* Optional custom header or message */}
                {selectProps.customMessage && (
                    <div className="text-center py-1 text-muted">
                        {selectProps.customMessage}
                    </div>
                )}

                {loadingg && agentmonitordata ? (
                    <div className="text-center">
                        <div className="loader"></div>
                    </div>
                ) : (
                    children
                )}

                {hasMore && (
                    <div className={`text-center mt-3 mx-2 ${loading ? 'd-none' : "d-block"}`}>
                        <button
                            className="btn btn-secondary w-100 bg-primary "
                            onClick={(e) => {
                                e.stopPropagation(); // Prevent dropdown from closing
                                loadMore(); // Call the loadMore function
                            }}
                            disabled={loading}
                        >
                            {loading ? "Loading..." : "Load More"}
                        </button>
                    </div>
                )}
            </components.MenuList>
        );
    };


    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setCurrentPage(page);
        }
    };

    const handleClearSearchFilter = () => {
        setUserid("")
        setfromDate("");
        settoDate("");
        setUserid('');
        setmodulename('')
        setipaddress('');
        setDateRangeText("Date Filter")
        setDateRange({ from: "", to: "" });
        setCurrentPage(1)
    };

    if (error) {
        <div>No found data</div>
    }

    return (

        <div className="wrapper">
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <div className="card mt-4">
                            <div className="rounded-top bg-white p-3 d-md-flex justify-content-sm-between">
                                <div className='d-md-flex mt-xl-0 mt-2 justify-content-between w-100'>
                                    <h2 className="mb-0 fs-3 text-wrap">User Logs Reports</h2>
                                    <div className='d-sm-flex justify-content-between mt-md-0 mt-3 gap-3'>
                                        <button onClick={handleClearSearchFilter}
                                            className='btn btn-secondary d-flex justify-content-center align-items-center gap-2'
                                            style={{ minWidth: 140, width: "100%" }}
                                        >
                                            <MdClear className='fs-5' />
                                            Clear Filter
                                        </button>
                                        <button
                                            onClick={DownloadLogs}
                                            className='btn btn-success d-flex justify-content-center align-items-center gap-2 mt-sm-0 mt-2'
                                            style={{ width: "100%" }}
                                            disabled={isExporting}
                                        >
                                            <BiExport className='fs-5' />
                                            {isExporting ? 'Exporting...' : `Export `}
                                        </button>

                                        <div className='w-100 d-flex justify-content-between'>
                                            <Dropdown className='w-100'>
                                                <Dropdown.Toggle
                                                    className="fw-semibold ms-sm-2 mt-sm-0 mt-2 w-100"
                                                    variant="primary"
                                                    id="dropdown-basic"
                                                >
                                                    {dateRangeText}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className="p-3 Date-Filter-Menu">
                                                    <div className="d-flex flex-column">
                                                        <label className="mb-2 fw-semibold">From</label>
                                                        <input
                                                            type="date"
                                                            name="from"
                                                            value={dateRange.from}
                                                            onChange={handleDateChange}
                                                            className="form-control mb-3"
                                                        />

                                                        <label className="mb-2 fw-semibold">To</label>
                                                        <input
                                                            type="date"
                                                            name="to"
                                                            value={dateRange.to}
                                                            onChange={handleDateChange}
                                                            className="form-control mb-3"
                                                        />

                                                        <div className="d-flex justify-content-between">
                                                            <button className="btn btn-primary w-100 me-1" onClick={applyDateFilter}>
                                                                Apply
                                                            </button>

                                                            <button className="btn btn-secondary w-100 ms-1" onClick={clearDateFilter}>
                                                                Clear
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body border-start-0 border-end-0 p-0">
                                <>
                                    <div className='table-responsive' style={{ minHeight: "300px" }}>
                                        <table className="table table-hover table-bordered text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th className='ps-3 sr-no'>SR No</th>
                                                    <th className='text-center status' style={{ minWidth: 151 }}>User Name</th>
                                                    <th>User Email</th>
                                                    <th>IP Address</th>
                                                    <th className='text-center' style={{ width: 151 }}>Modules</th>
                                                    <th className='text-center'>Description</th>
                                                    <th className='createdat text-center'>CreatedAt</th>
                                                </tr>
                                                <tr>
                                                    <th className='ps-3'></th>
                                                    <th>
                                                        <div className="dropdown-container">
                                                            {/* <select
                                                                onChange={(e) => setUserid(e.target.value)}
                                                                className="form-control mb-2"
                                                                value={userid}
                                                            >
                                                                <option value="">All Users</option>
                                                                {allAgents.map((user, index) => (
                                                                    <option key={user.id || index} value={user.id}>
                                                                        {user?.name || `User ${index + 1}`}
                                                                    </option>
                                                                ))}
                                                            </select> */}

                                                            <CreatableSelect
                                                                name="smscampuser"
                                                                isMulti={false}
                                                                isSearchable={true}
                                                                options={userOptions}
                                                                filterOption={(o) => true}
                                                                className='shadow-none'
                                                                value={userOptions.find(option => option.value === Number(userid)) || null}
                                                                onChange={handleSelectChange}
                                                                onInputChange={(inputValue) => handleSearchChange(inputValue)}
                                                                placeholder="Search and select user"
                                                                classNamePrefix="select"

                                                                formatOptionLabel={(option: OptionType) => (
                                                                    <div className="d-flex justify-content-between align-items-center border-bottom py-1">
                                                                        <div>
                                                                            <p className="fw-semibold mb-0">
                                                                                {option.label}
                                                                            </p>{" "}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                styles={{
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        maxHeight: "200px", // Set the maximum height of the dropdown
                                                                        overflowY: "auto", // Add scrolling for overflowing content
                                                                    }),
                                                                    menuList: (base) => ({
                                                                        ...base,
                                                                        maxHeight: "200px", // Ensure menu list respects dropdown height
                                                                    }),
                                                                }}
                                                                components={{
                                                                    IndicatorSeparator: () => null,
                                                                    DropdownIndicator: () => null,
                                                                    MenuList: (props) => (
                                                                        <CustomMenuList
                                                                            {...props}
                                                                            hasMore={hasMore} // Custom prop
                                                                            loading={loadingg} // Custom prop
                                                                            loadMore={loadMore} // Custom prop
                                                                        />
                                                                    ),
                                                                    MultiValue
                                                                }}
                                                            />
                                                        </div>
                                                    </th>

                                                    <th></th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            placeholder="Search IP Address"
                                                            onChange={(e) => setipaddress(e.target.value.trim())}
                                                            value={ipaddress}
                                                            className="form-control"
                                                        />
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            placeholder="Search Module"
                                                            onChange={(e) => setmodulename(e.target.value.trim())}
                                                            value={modulename}
                                                            className="form-control"
                                                        />
                                                    </th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {loading ? (
                                                    <tr><td colSpan={7} height={100}><div className="text-center"><div className="loader"></div></div></td></tr>
                                                ) : !userlogsreportdata || userlogsreportdata.length === 0 ? (
                                                    <tr><td colSpan={7} height={50}><div className="text-center"><p className='mb-0 fs-5 fw-semibold'>No data found</p></div></td></tr>
                                                ) : (
                                                    recordreport.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td className='ps-3'>{(currentPage - 1) * limit + index + 1}</td>
                                                            <td className='text-center'>{item.UserName || '-'}</td>
                                                            <td className='text-center'>{item.UserEmail || '-'}</td>
                                                            <td>{item.IP_Address || "-"}</td>
                                                            <td>{item.Module || "-"}</td>
                                                            <td className='text-center'>{item.Description || '-'}</td>
                                                            <td className='createdat text-center'>{formatDate(item.createdAt) || '-'}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {!userlogsreportdata || userlogsreportdata.length === 0 ? (
                                        <div></div>
                                    ) : (
                                        <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                                            <RenderPaginationButtons
                                                info={info}
                                                currentPage={currentPage}
                                                handlePageChange={handlePageChange}
                                            />
                                        </div>
                                    )}
                                </>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        </div >
    );
}

export default Userlogsreports;
